import * as React from "react";
const SvgGooglePdf = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC3DF",
  d: "m14 2 6 6h-6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED756C",
  d: "M4 5a3 3 0 0 1 3-3h7v3a3 3 0 0 0 3 3h3v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8 18H7v-5h1.5a1.5 1.5 0 0 1 0 3H8zm0-3h.5a.5.5 0 0 0 0-1H8z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15 18h1v-2h1v-1h-1v-.5a.5.5 0 0 1 .5-.5h.5v-1h-.5a1.5 1.5 0 0 0-1.5 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M11 18v-5h1.5a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5zm1.5-1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H12v3z",
  clipRule: "evenodd"
}));
export default SvgGooglePdf;
//# sourceMappingURL=GooglePdf.js.map